import { api } from './client';

interface PresignedUpload {
  uploadUrl: string;
  signature: string;
  timestamp: number;
  apiKey: string;
  folder: string;
}

function getUploadCredentials(filename: string, contentType: string, folder: string): Promise<PresignedUpload> {
  return api.post<PresignedUpload>('/api/v1/uploads/presigned', {
    filename,
    contentType,
    folder,
  });
}

// Uploads a file directly to Cloudinary using backend-issued presigned credentials — mirrors
// rteh's cloudinaryUpload() pattern (see rteh/src/features/users/hooks.ts).
async function uploadFile(file: File, folder: string): Promise<string> {
  const creds = await getUploadCredentials(file.name, file.type, folder);

  const formData = new FormData();
  formData.append('file', file);
  formData.append('api_key', creds.apiKey);
  formData.append('timestamp', String(creds.timestamp));
  formData.append('signature', creds.signature);
  formData.append('folder', creds.folder);

  const res = await fetch(creds.uploadUrl, { method: 'POST', body: formData });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(`Upload failed: ${json?.error?.message ?? res.statusText}`);
  }
  return json.secure_url as string;
}

export function uploadCargoPhoto(file: File): Promise<string> {
  return uploadFile(file, 'requests');
}

export function uploadDisputeEvidence(file: File): Promise<string> {
  return uploadFile(file, 'disputes');
}

export function uploadEquipmentPhoto(file: File): Promise<string> {
  return uploadFile(file, 'saved-equipment');
}

export function uploadAvatarPhoto(file: File): Promise<string> {
  return uploadFile(file, 'avatars');
}
